import { useContext } from "react";
import { TranslationContext } from "../../Components/TranslationContext";

function NotFound() {
  const { translations } = useContext(TranslationContext);
  return <div className="notFoundMessage">{translations.not_found}</div>;
}
export default NotFound;
